import { api } from '@creditsights/api-ui-web';
import { DealMarketStatus, ModerationStatus, SecurityType } from '../models/CompanyDeal';
import { SecuritiesResults } from '../models/Securities';
import { filterMapper } from '../utils/filter.utils';
import { mapCountries, mapSectors } from '../utils/tag.utils';

const marketStatusFilterMapping = {
  [SecurityType.BOND]: {
    [DealMarketStatus.InMarket]: { values: ['Announced'] },
    [DealMarketStatus.Expected]: { values: ['Rumoured'] },
    [DealMarketStatus.Hung]: { values: ['Pulled'] },
    [DealMarketStatus.Completed]: {
      excluded_values: ['Announced', 'Rumoured', 'Pulled'],
    },
  },
  [SecurityType.LOAN]: {
    [DealMarketStatus.InMarket]: { values: ['Announced'] },
    [DealMarketStatus.Expected]: { values: ['Expected'] },
    [DealMarketStatus.Hung]: { values: ['Hung Syndication (Outstanding)', 'Hung Syndication'] },
    [DealMarketStatus.Completed]: {
      excluded_values: ['Announced', 'Expected', 'Hung Syndication (Outstanding)', 'Hung Syndication'],
    },
  },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchSecurities = async (type, sort, marketStatus, filterConfig, pageSize, page = 1) => {
  const { data } = await api.post<SecuritiesResults>('common/v1/securities', {
    filters: {
      security_type: { values: [type] },
      deal_status: marketStatusFilterMapping[type][marketStatus],
      moderation: { values: [ModerationStatus.PUBLISHED, ModerationStatus.SENT] },
      ...filterConfig,
    },
    skip: (page - 1) * pageSize,
    take: pageSize,
    sort: sort.field,
    sortDesc: !sort.asc,
  });

  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchSecurityFilters = async (type) => {
  const filters = [
    {
      id: 'company_name',
      name: 'Company',
    },
    {
      id: 'region',
      name: 'Region',
    },
    {
      id: 'country_tag',
      name: 'Country',
    },
    {
      id: 'sector_tag',
      name: 'Sector/Subsector',
    },
    {
      id: 'uop',
      name: 'UOP',
    },
    {
      id: 'deal_type',
      name: 'Type',
    },
    {
      id: 'issuer',
      name: 'Issuer',
    },
    {
      id: 'leads.company',
      name: 'Lead',
    },
    {
      id: 'sponsors.sponsor',
      name: 'Sponsor',
    },
    {
      id: 'deal_status',
      name: 'Deal status',
    },
  ];

  const promises = filters.map((filter) =>
    api.post(`common/v1/securities/filters/${filter.id}`, {
      filters: {
        security_type: {
          values: [type],
        },
      },
      take: 5000,
    })
  );

  const [results, { data: additionalFilters }] = await Promise.all([Promise.all(promises), api.get('common/v1/tags/filters')]);
  const resp: any = {};

  results.forEach((result, index) => {
    const filter = filters[index];

    resp[filter.id] = {
      name: filter.name,
      data: filterMapper(result.data.filter((i) => !!i)),
    };
  });

  resp.sector_tag.data = mapSectors(additionalFilters[6].options);
  resp.country_tag.data = mapCountries(additionalFilters[0].options, resp.country_tag.data);

  return resp;
};
